import { IEvent, IMessageUnion } from '../../../global';
export default (message: IMessageUnion): message is IEvent => {
  return (message as IEvent).__typename === 'Event';
};
